import axios from "axios";

const axiosInst = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}/api/v1.0/`,
  timeout: 60000
});

export default axiosInst;